import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import Header from "../common/Header";
import { useSearchParams } from "react-router-dom";

export default function EvaluationConfirm() {
  const [searchParams] = useSearchParams();

  const handleSelfEvaluationButton = () => {
    const listId = searchParams.get("listId");
    const termId = searchParams.get("termId");
    window.location.href = `/Evaluation?listId=${listId}&termId=${termId}`;
  };

  const handleOtherEvaluationButton = () => {
    const listId = searchParams.get("listId");
    const termId = searchParams.get("termId");
    window.location.href = `/Evaluation?isOther=${true}&listId=${listId}&termId=${termId}`;
  };

  const handleEvaluationComparisonButton = () => {
    const listId = searchParams.get("listId");
    const termId = searchParams.get("termId");
    window.location.href = `/EvaluationComparison?listId=${listId}&termId=${termId}`;
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Header />
      <Container maxWidth="sm">
        <Box
          sx={{
            marginTop: 9,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h5" variant="h6" align="left">
            2．自分自身のことを知ろう
          </Typography>
        </Box>

        <Box
          sx={{
            margin: 1,
            display: "flex"
          }}
        >
          <div>
            <FormControl fullWidth sx={{ mr: 3, ml: 3, mt: 2 }}>
              <Button
                size="large"
                style={{ color: "white", justifyContent: "left" }}
                fullWidth
                variant="contained"
                onClick={handleSelfEvaluationButton}
                sx={{ bgcolor: "#82b1ff" }}
              >
                自己評価
              </Button>
            </FormControl>

            <FormControl fullWidth sx={{ mr: 3, ml: 3, mt: 5 }}>
              <Button
                size="large"
                style={{ color: "white", justifyContent: "left" }}
                fullWidth
                variant="contained"
                onClick={handleOtherEvaluationButton}
                sx={{ bgcolor: "#82b1ff" }}
              >
                他者評価
              </Button>
            </FormControl>

            <FormControl fullWidth sx={{ mr: 3, ml: 3, mt: 5 }}>
              <Button
                size="large"
                style={{ color: "white", justifyContent: "left" }}
                fullWidth
                variant="contained"
                onClick={handleEvaluationComparisonButton}
                sx={{ bgcolor: "#82b1ff" }}
              >
                違いをチェック
              </Button>
              <div style={{ fontSize: "14px", textAlign: "start" }}>
                <h8>※自己評価と他者評価が登録されている場合に違いが表示されます</h8>
              </div>
            </FormControl>
          </div>
        </Box>
      </Container>
      
      <Container maxWidth="sm">
        <div>
          <Box sx={{ alignItems: "right", justifyContent: "right", m: 2, mr: -2, display: "flex" }}>
            <Button
              variant="contained"
              size="medium"
              href="/StudentMenu"
              sx={{ bgcolor: "#82b1ff", marginLeft: "auto" }}
            >
              戻る
            </Button>
          </Box>
        </div>
      </Container>
    </Box>
  );
}
